import { ColumnDefinition } from "../../../../../../generic/universal-table/types/column.types";
import { convertToDate } from "../../../../../../modules/convertDateString";
import { ExpirationReportRow } from "../types/row";

// Single source for both GridTable columns and the Excel export (via columnsToExcel).
// expirationDate arrives as a raw YYYYMMDD string: declared as 'string' on purpose —
// lexicographic order equals chronological order, while the 'date' renderer/sort
// would choke on the format (Invalid Date / NaN).
export const EXPIRATION_REPORT_COLUMNS: ColumnDefinition<ExpirationReportRow>[] = [
    { key: 'location', title: 'איתור', dataType: 'string' },
    { key: 'productDesc', title: 'פריט', dataType: 'string', sortable: true },
    // GrowerName arrives padded with trailing spaces — trimmed for both grid and Excel.
    { key: 'GrowerName', title: 'מגדל', dataType: 'string', sortable: true, formatValue: (value) => String(value ?? '').trim() },
    { key: 'barcode', title: 'ברקוד', dataType: 'string' },
    { key: 'expirationDate', title: 'פג תוקף', dataType: 'string', sortable: true, formatValue: (value) => convertToDate(value as string) },
    { key: 'weight', title: 'משקל / יחידות', dataType: 'number', sortable: true },
    { key: 'packQty', title: 'יתרת כמות', dataType: 'number' },
    { key: 'EntryDetailNum', title: 'כניסה', dataType: 'string', sortable: true },
    // entryDate is a raw YYYYMMDD string, same as expirationDate above.
    { key: 'entryDate', title: 'תאריך כניסה', dataType: 'string', sortable: true, formatValue: (value) => convertToDate(value as string) },
]
